import React, {useState, useContext, createContext, useMemo, Dispatch, SetStateAction,} from 'react';

interface AppContextValue {
  channels: any[]; // Corrected to any[]
  updateChannels: Dispatch<SetStateAction<any[]>>;
}
const defaultInitialState = {
  channels: [],
  updateChannels: () => { console.log("void")},
};

const AppContext = createContext<AppContextValue | undefined>(defaultInitialState);

interface componentHtml {
  children?: React.ReactNode; 
}

//const AppContext = createContext<AppContextValue | undefined>(undefined);

export function useApp() {
  return useContext(AppContext);
}

export const AppProvider: React.FC<componentHtml> = ({children}) => {
  const [channels, setChannels] = useState<any[]>([]);

  const contextValue = useMemo<AppContextValue>(() => ({
    channels,
    updateChannels: setChannels,
  }), [channels, setChannels]);

  return (
    <AppContext.Provider value={contextValue}>
      {children}
    </AppContext.Provider>
  );
}
